// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { EntityTypeId } from '../tbs/entity-type-id.js';


export class PlaceFactoryOrderAction implements flatbuffers.IUnpackableObject<PlaceFactoryOrderActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PlaceFactoryOrderAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPlaceFactoryOrderAction(bb:flatbuffers.ByteBuffer, obj?:PlaceFactoryOrderAction):PlaceFactoryOrderAction {
  return (obj || new PlaceFactoryOrderAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPlaceFactoryOrderAction(bb:flatbuffers.ByteBuffer, obj?:PlaceFactoryOrderAction):PlaceFactoryOrderAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PlaceFactoryOrderAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GamePlaceFactoryOrder;
}

factoryId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

etypeId():EntityTypeId {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EntityTypeId.Infantry;
}

static startPlaceFactoryOrderAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GamePlaceFactoryOrder);
}

static addFactoryId(builder:flatbuffers.Builder, factoryId:number) {
  builder.addFieldInt32(1, factoryId, 0);
}

static addEtypeId(builder:flatbuffers.Builder, etypeId:EntityTypeId) {
  builder.addFieldInt16(2, etypeId, EntityTypeId.Infantry);
}

static endPlaceFactoryOrderAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPlaceFactoryOrderAction(builder:flatbuffers.Builder, type:ActionType, factoryId:number, etypeId:EntityTypeId):flatbuffers.Offset {
  PlaceFactoryOrderAction.startPlaceFactoryOrderAction(builder);
  PlaceFactoryOrderAction.addType(builder, type);
  PlaceFactoryOrderAction.addFactoryId(builder, factoryId);
  PlaceFactoryOrderAction.addEtypeId(builder, etypeId);
  return PlaceFactoryOrderAction.endPlaceFactoryOrderAction(builder);
}

unpack(): PlaceFactoryOrderActionT {
  return new PlaceFactoryOrderActionT(
    this.type(),
    this.factoryId(),
    this.etypeId()
  );
}


unpackTo(_o: PlaceFactoryOrderActionT): void {
  _o.type = this.type();
  _o.factoryId = this.factoryId();
  _o.etypeId = this.etypeId();
}
}

export class PlaceFactoryOrderActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GamePlaceFactoryOrder,
  public factoryId: number = 0,
  public etypeId: EntityTypeId = EntityTypeId.Infantry
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return PlaceFactoryOrderAction.createPlaceFactoryOrderAction(builder,
    this.type,
    this.factoryId,
    this.etypeId
  );
}
}
